import { render, staticRenderFns } from "./DependencyGraph.vue?vue&type=template&id=3e547b16&"
import script from "./DependencyGraph.vue?vue&type=script&lang=js&"
export * from "./DependencyGraph.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports